import axios from 'axios'

export type PriceUpdateBatch = {
  processed: number
  updated: number
  failed: Array<{id: number; brojNaloga: string; error: string}>
  has_more: boolean
  next_after_id: number | null
}

type PriceUpdateResponse = {error: number; message: string; data: PriceUpdateBatch}

const isBatch = (data: PriceUpdateBatch | undefined): data is PriceUpdateBatch =>
  !!data &&
  Number.isInteger(data.processed) &&
  data.processed >= 0 &&
  Number.isInteger(data.updated) &&
  data.updated >= 0 &&
  Array.isArray(data.failed) &&
  typeof data.has_more === 'boolean' &&
  (!data.has_more || (Number.isInteger(data.next_after_id) && Number(data.next_after_id) > 0))

export async function updatePanelPrices(afterId = 0): Promise<PriceUpdateResponse> {
  let result: PriceUpdateResponse
  try {
    const response = await axios.post<PriceUpdateResponse>(
      `${process.env.REACT_APP_API_URL}/paneli/update-cijena-naloga`,
      {after_id: afterId}
    )
    result = response.data
  } catch (error) {
    // A partially successful batch is returned as HTTP 502, with a usable cursor.
    if (axios.isAxiosError(error) && isBatch(error.response?.data?.data)) {
      result = error.response!.data
    } else {
      const message = axios.isAxiosError(error) ? error.response?.data?.message : undefined
      throw new Error(message || 'Zahtjev nije završen. Provjerite vezu i pokušajte ponovo.')
    }
  }
  if (
    !isBatch(result?.data) ||
    (result.data.has_more && Number(result.data.next_after_id) <= afterId)
  ) {
    throw new Error(result?.message || 'Server nije vratio ispravan rezultat osvježavanja.')
  }
  return result
}
